import './UpgradeText.css';
import { useContext, useEffect, useState } from 'react';

import { Banner } from '@/components/Banner/Banner';
import { RichText } from '@/components/RichText/RichText';
import { Context } from '@/components/Store';
import { languageStrings } from '@/l18n/de';
import { getBundle } from '@/lib/http';

const UpgradeText = () => {
	const [state] = useContext(Context);
	const [currentProduct, setCurrentProduct] = useState('');

	useEffect(() => {
		void (async () => {
			if (state?.upgrade?.isMovableSubscription && state?.upgrade?.moveFromBundleRef) {
				const { name } = await getBundle(state.upgrade.moveFromBundleRef);
				setCurrentProduct(name);
			}
		})().catch(() => {
			// Keep currentProduct as empty string on error
		});
	}, [state.upgrade.isMovableSubscription, state.upgrade.moveFromBundleRef]);

	return state?.upgrade?.isMovableSubscription ? (
		<Banner className="banner-okay">
			{currentProduct ? (
				<div>
					<RichText
						message={languageStrings.upgrade.currentProductKnown(
							currentProduct,
							state.bundle?.name || ''
						)}
					/>
				</div>
			) : (
				<div>
					<RichText
						message={languageStrings.upgrade.currentProductUnknown(state.bundle?.name || '')}
					/>
				</div>
			)}
		</Banner>
	) : null;
};

export { UpgradeText };
